import React from 'react';
import PropTypes from 'prop-types';

import {
    FormLabel,
    Checkbox,
    FormDescription,
} from '/components/forms/components';

import '/components/forms/components/checkboxes-field/checkboxes-field.scss';

const CheckboxesField = ({ name, label, required, options, description }) => (
    <div className="form-item">
        <FormLabel label={label} required={required} />
        {options.map((option) => (
            <Checkbox name={name} label={option.label} value={option.value} key={option.value} />
        ))}
        <FormDescription description={description} />
    </div>
);

CheckboxesField.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }),
    ),
};

CheckboxesField.defaultProps = {
};

export { CheckboxesField };
